import { UserDetails } from '../context/types';

export const isNewUser = (user: UserDetails) => {
  // Check if user was created within the last 10 minutes (10 * 60 * 1000 milliseconds)
  return !!(user.created && user.created >= Date.now() - 1000 * 60 * 10);
};
